const Host = require('./hosts');

const { apihqDomain, stockDiagnosisHost, gmgQuoteHost, quotes, money, rankHost, circle, sms, user, stockQuoteHost, plateChart, rjhyQuoteHost, rjhyNewsHost, file, rjhyQuoteSector, doNews, hqInfo, hqToken, plateBasic, rjhyActivityManage, rjhyEduUranus } = Host(process.env.NODE_ENV);
const channel = 'channelH5';
// fdzqQuote

module.exports = {
    quote: {
        getLv2AdayInfo: ``, // A股主力资金今日jing
        announcementDetailv2: `${apihqDomain}/news/api/1/stock/a/announcements/detail`,
        newsDetailv2: `${apihqDomain}/news/api/1/stock/a/finance/detail`,
        getHandicap: `${apihqDomain}/finance/api/2/stock/quote/handicap`, // A股盘口数据V2
        getStockName: `${gmgQuoteHost}/getstockname`, // 获取个股名称
        getmainbusiness: `${gmgQuoteHost}/stock/quotes/getmainbusiness`, // 获取股票的主营业务
        queryStockSearch: `${gmgQuoteHost}/searchshszv1`, // 个股模糊搜索
        getAShareProfile: `${gmgQuoteHost}/stock/quotes/getAShareProfile`, // A股公司简况
        getDividendDistribution: `${gmgQuoteHost}/stock/quotes/getDividendDistribution`, // 分红配送
        hotSearchV2: `${gmgQuoteHost}/stock/hotSearchV2`, // 分红配送
        getStockAlarm: `${gmgQuoteHost}/stock/alarm/getStockAlarm`, // 沪深A股个股异动
        getStockThemes: `${gmgQuoteHost}/stock/quotes/getStockThemes`, // 概念机会分析
        articles: `${doNews}/rjhy-quote-news/api/1/stock/finance/news/list`, // 查询资讯列表
        newsOne: `${gmgQuoteHost}/report/news/one`, // 研报列表
        ratingInfo: `${gmgQuoteHost}/report/rating/info`, // 研报评级统计
        profitInfo: `${gmgQuoteHost}/report/profit/info`, // 研报盈利评测
        newsDetail: `${gmgQuoteHost}/stock/newsDetailv2`, // 资讯详情
        detailByNewsId: `${gmgQuoteHost}/report/news/detailByNewsId`, // 研报详情
        announcementDetail: `${gmgQuoteHost}/stock/announcementDetail`, // 公告详情
        newsDetailNew: `${doNews}/rjhy-news-center/api/center/1/stock/article/detail`, // 新资讯详情
        detailByNewsIdNew: `${doNews}/rjhy-quote-news/api/1/stock/a/report/detail`, // 新研报详情
        announcementDetailNew: `${doNews}/rjhy-news-center/api/center/1/stock/announce/detail`, // 新公告详情
        gene: `${gmgQuoteHost}/stock/quote/gene`, // 涨停基因
        stockDetail: `${gmgQuoteHost}/stock/detailv1`,
        getFdStockDetail: `${gmgQuoteHost}/stock/quotes/getFdStockDetail`,
        httpV30: `${quotes}/api/v30`, // test
        getBillList: `${money}/api/openapi.php/CN_Bill.GetBillList`, // 大单 ?num=100000&symbol=sz300344
        getToken: `${hqToken}/api/v2/AuthGetToken`,
        getKline : `${hqInfo}/infoapi/v2/hisquote/v2`,
        getIEKline: `${gmgQuoteHost}/stock/quote/v30v2`,
        getStatistics: `${gmgQuoteHost}/stock/quote/lastprice`,
        getsigntoken: `${gmgQuoteHost}/symbol/getsigntoken`, // 获取签名
        tradingdays: `${gmgQuoteHost}/stock/tradingdays`, // 最近交易日 ?market=sh&limit=3
        scrollbar: `${gmgQuoteHost}/stock/quote/scrollbar`, // 新闻速递滚动条
        hsFinance: `${gmgQuoteHost}/stock/quote/finance/report/detail`, // A股财务
        financeStockQuota: `${gmgQuoteHost}/stock/quotes/getStockQuota`, // 港美股财务
        financeStockFinance: `${gmgQuoteHost}/stock/quotes/getStockFinance`, // 港美股财务
        hkStockInfoList: `${gmgQuoteHost}/stock/quotes/getHKStockData`, // 港股简讯
        usStockInfoLists: `${gmgQuoteHost}/stock/quotes/getData`, //美股简讯
        // bkRank: `${stockQuoteHost}/deal/queryUpDownPlateRank`, // 板块排行
        // bkUpDownPlate: `${stockQuoteHost}/deal/queryUpDownPlate`,
        bkRank: `${rjhyQuoteSector}/pc/plate/block/quote/list`,
        bkUpDownPlate: `${rjhyQuoteSector}/pc/plate/block/category/list/top`,
        rankList: `${stockQuoteHost}/deal/queryRankStocks`, // 排行榜单
        plateDetail: `${rankHost}/plate/detail`, // 板块详情
        constituentList: `${stockQuoteHost}/deal/queryStockGrp`, // 板块下成分股
        blockDetailPart: `${rjhyQuoteSector}/pc/plate/block/stock/group`, // 新板块下成分股列表
        cashFlow: `${stockQuoteHost}/deal/getFundFlow`, // 板块今日资金流向
        todayCapitalFlow: `${rjhyQuoteSector}/pc/plate/block/fund/flow/detail`, // 新板块今日资金流向
        cashFlowFive: `${stockQuoteHost}/deal/queryCapitalFlow`, // 板块今日资金流向
        fiveDayCapitalFlow: `${rjhyQuoteSector}/capital/flow/history`, // 新板块五日资金流向
        plateTop3Lists: `${rjhyQuoteHost}/deal/stock2PlateTop3`, //个股所属板块
        queryStockGrp: `${rjhyQuoteHost}/deal/queryStockGrp`, // 板块成分股列表
        queryIndividualStockFiSeByCode: `${rjhyQuoteHost}/deal/queryIndividualStockFiSeByCode`, // 两融余额图
        query2IndividualStockFinaSecuTable: `${rjhyQuoteHost}/deal/query2IndividualStockFinaSecuTable`, // 融资融券交易数据
        query2TradingDetailTable: `${rjhyQuoteHost}/deal/queryIndividualFiSeByCode`, // 历史两融买卖明细
        getEtfHistory: `${gmgQuoteHost}/stock/getetfstockhistory`,
        multipleIndex: `${rjhyEduUranus}/multiple/index`,
    },
    zbHttp: {
        login: `/v30/login`, //  换取token
        busi: `/v30/busi`, // http 行情 v30
    },
    aiDiagnosis: {
        summary: `${stockDiagnosisHost}/jfztPc/BEEF00C14F8274BE5FACDDA11568F187/summary/stock/diagnosis`,
        coefficientChart: `${stockDiagnosisHost}/jfztPc/stock/diagnosis/coefficientChart`,
        fundPerspective: `${stockDiagnosisHost}/jfztPc/stock/diagnosis/fundPerspective`,
        cashInflow: `${stockDiagnosisHost}/jfztPc/token/period/cash/inflow`,
        bigPerspective: `${stockDiagnosisHost}/jfztPc/stock/diagnosis/bigPerspective`,
        newsList: `${stockDiagnosisHost}/jfztPc/token/stock/news`,
        valuePerspective: `${stockDiagnosisHost}/jfztPc/stock/diagnosis/valuePerspective`,
    },
    rank: {
        summary: `${rankHost}/edu/stock/rank/summary`, //今日龙虎榜汇总
        list: `${rankHost}/edu/stock/rank/list`, //今日龙虎榜列表
        salesList: `${rankHost}/edu/department/rank/list`, //营业部列表
        stockDetail: `${rankHost}/edu/stock/rank/detail`, //营业部列表
        departmentDetail: `${rankHost}/edu/department/detail`, //营业部详情
        depOptionList: `${rankHost}/edu/department/opt/list`, //营业部操作记录
    },
    stockBar: {
        list: `${circle}/news/customer/stockbar/list/${channel}`, // 股圈列表
        publish: `${circle}/news/customer/publish/stockbar/unaudited/${channel}`,
        detail: `${circle}/news/customer/stockbar/detail/${channel}`,
        support: `${circle}/review/customer/support/news/${channel}`, // 点赞观点
        unSupport: `${circle}/review/customer/unSupport/news/${channel}`, // 取消点赞观点
        supportReview: `${circle}/review/customer/support/review/${channel}`, // 点赞评论
        unSupportReview: `${circle}/review/customer/unSupport/review/${channel}`, // 取消点赞评论
        publishDetail: `${circle}/review/customer/reviews/${channel}`,
        reviewList: `${circle}/news/customer/stockbar/review/list/${channel}`,
    },
    sms: {
        captcha: `${sms}/${channel}/captcha/sms/freesend`,
    },
    user: {
        login: `${user}/user/${channel}/sms/login`,
    },
    plateChart: {
        tred: `${plateChart}/pc/candle/plate/trend`, //板块分时数据
        historyList: `${plateChart}/${channel}/candle/plate/list`, //历史K线数据
        fiveTrend: `${plateChart}/${channel}/candle/plate/trend/5`, //5日K线数据
        plateBasicInfo: `${plateBasic}/query/exchange`,
    },
    news: {
        getSpecifiedColumnList: `${rjhyNewsHost}/1/popularize/news/specifiedColumnList`,
        getArticleDetail: `${rjhyNewsHost}/1/9fztgw/news/content`,
    },
    activity: {
        getPages: `${rjhyActivityManage}/activities/pages`,
    },
    file: {
        uploadFile: `${file}/file/${channel}/upload`,
    },
};
